var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thanks"},[_c('div',{staticClass:"wrap"},[_vm._m(0),_c('div',{staticClass:"button"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("トップへ戻る")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h1',[_vm._v("お問い合わせを承りました")]),_c('p',[_vm._v(" お問い合わせを承りました。"),_c('br'),_vm._v("お問い合わせ内容を、ご入力のメールアドレスに送信しました。20分経過しても届かない場合は、迷惑メールボックスの中をご確認ください。 ")])])
}]

export { render, staticRenderFns }